<p class="m-3 h3">
  Job Schedule<span
    *ngIf="
      JobScheduleViewModel !== null &&
      JobScheduleViewModel.jobDescription !== ''
    "
  >
    - {{ JobScheduleViewModel.jobDescription }}</span
  >
</p>
<hr />
<div class="control-section mb-2 me-3" style="min-height: 590px">
  <!-- <form [formGroup]="wizardform" (ngSubmit)="showNextStep()"> -->
  <div
    class="col-lg-9 content-wrapper"
    style="width: 100%; padding: 6px 0px 0px 6px"
  >
    <ng-wizard [config]="config" (stepChanged)="stepChanged($event)">
      <ng-wizard-step [title]="'1 - Phases'">
        <hr />
        <div class="row">
          <div class="col-lg-10 col-md-12 col-sm-12">
            <div class="row mt-2">
              <div class="col-md-4 col-sm-12">
                <div class="form-group">
                  <ejs-datepicker
                    #ejDatePicker
                    cssClass="e-outline"
                    name="startDate"
                    placeholder="Select a Date"
                    floatLabelType="Auto"
                    [(ngModel)]="selectedJobs.startDate"
                    (change)="onDateChange($event)"
                    #startDate="ngModel"
                    [min]="minDate"
                    [allowEdit]="allowEditForDate"
                    required
                  >
                  </ejs-datepicker>
                  <div class="e-error" *ngIf="submitted && !startDate.valid">
                    <div>* Date is required.</div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <ejs-dropdownlist
                  id="company"
                  #samples
                  cssClass="e-outline"
                  [dataSource]="CompanyDataSource"
                  [fields]="Companyfields"
                  [(ngModel)]="selectedJobs.companyId"
                  placeholder="Select a Company"
                  floatLabelType="Auto"
                  [allowFiltering]="true"
                  (change)="onCompanyChange($event)"
                  [enabled]="!showSelectedPhaseGrid"
                  required
                >
                </ejs-dropdownlist>
              </div>
              <div class="col-md-3 col-sm-12">
                <ejs-checkbox
                  #checkbox
                  label="Inspector Needed"
                  [(ngModel)]="JobScheduleViewModel.inspectorNeeded"
                  [checked]="JobScheduleViewModel.inspectorNeeded"
                >
                </ejs-checkbox>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-4 col-sm-12">
                <ejs-dropdownlist
                  id="job"
                  #samples
                  cssClass="e-outline"
                  [dataSource]="jobData"
                  [fields]="jobfields"
                  placeholder="Select a Job"
                  [(ngModel)]="JobScheduleViewModel.jobId"
                  [allowFiltering]="true"
                  floatLabelType="Auto"
                  (change)="onJobChange($event)"
                  (filtering)="onJobDataFiltering($event)"
                  [enabled]="!showSelectedPhaseGrid"
                  [showClearButton]="false"
                  >
                </ejs-dropdownlist>
                <div
                  class="e-error"
                  *ngIf="
                    submitted &&
                    (JobScheduleViewModel.jobId === undefined ||
                      JobScheduleViewModel.jobId === '')
                  "
                >
                  <div>* Select job</div>
                </div>
              </div>
              <div class="col-md-4 col-sm-12">
                <ejs-dropdownlist
                  id="item"
                  #samples
                  cssClass="e-outline"
                  [dataSource]="itemDataSource"
                  [fields]="itemfields"
                  placeholder="Select a Item"
                  [(ngModel)]="SelectedItem"
                  floatLabelType="Auto"
                  [allowFiltering]="true"
                  (change)="onItemChange($event)"
                  (filtering)="onItemFiltering($event)"
                  [enabled]="!showSelectedPhaseGrid"
                >
                </ejs-dropdownlist>
              </div>
              <div class="col-md-3 col-sm-12">
                <ejs-checkbox
                  #checkbox
                  label="Inspector Called"
                  [(ngModel)]="JobScheduleViewModel.inspectorCalled"
                  [checked]="false"
                >
                </ejs-checkbox>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-12 col-xs-12">
            <button
              class="e-btn e-info"
              id="addedPhase"
              *ngIf="showaddedPhaseBtn"
              (click)="OnToggleButtonClick()"
            >
              {{ toggleButtonText }}
            </button>
          </div>
        </div>

        <div
          class="row mt-2"
          style="padding: 10px"
          *ngIf="!showSelectedPhaseGrid"
        >
          <ejs-grid
            #grid
            class="px-0"
            [dataSource]="gridDataSource"
            allowTextWrap="true"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [toolbar]="toolbar"
            [filterSettings]="filterSettings"
            allowSorting="true"
            [sortSettings]="sortOptions"
          >
            <e-columns>
              <!-- <e-column headerText='ACTION' width='100px'>
                <ng-template #template let-gridDataSource>
                  <div>
                    <button type="button" ejs-button Class="e-info btn-bg mr-2" title="Add"
                      *ngIf="!gridDataSource.isAdded && !gridDataSource.isAddedToJobSchedule"
                      (click)='PhaseAddToObject($event);'><i class="fa fa-plus"></i></button>
                    <button type="button" ejs-button Class="e-success btn-bg mr-2" title="Added to Phase"
                      *ngIf="gridDataSource.isAdded || gridDataSource.isAddedToJobSchedule "><i class="fa fa-check"
                        aria-hidden="true"></i></button>
                  </div>
                </ng-template>
              </e-column> -->
              <e-column headerText="ACTION" width="100px">
                <ng-template #template let-gridDataSource>
                  <div>
                    <button
                      type="button"
                      ejs-button
                      Class="e-info btn-bg mr-2"
                      title="Add"
                      *ngIf="
                        !gridDataSource.isAdded &&
                        !gridDataSource.isAddedToJobSchedule
                      "
                      (click)="PhaseAddToObject($event)"
                    >
                      <i class="fa fa-plus"></i>
                    </button>

                    <button
                      type="button"
                      ejs-button
                      Class="e-danger btn-bg mr-2"
                      title="Added to Phase"
                      (click)="RemoveActivePhase($event)"
                      *ngIf="
                        gridDataSource.isAdded ||
                        gridDataSource.isAddedToJobSchedule
                      "
                    >
                      <i class="fa fa-ban" aria-hidden="true"></i>
                    </button>
                  </div>
                </ng-template>
              </e-column>
              <e-column
                field="phaseIdDescription"
                headerText="PHASE ID"
                width="220px"
                style="font-weight: 500"
              >
              </e-column>
              <e-column
                field="itemDescription"
                headerText="ITEM DESCRIPTION"
                width="350px"
                style="font-weight: 500"
              >
              </e-column>
              <e-column
                field="estLabourProd"
                headerText="BID PROD"
                width="125px"
                style="font-weight: 500"
              ></e-column>
              <e-column
                field="bidHrs"
                headerText="Bid Hrs"
                width="110px"
                style="font-weight: 500"
              ></e-column>
              <e-column
                field="jtdHrs"
                headerText="JTD Hrs"
                width="110px"
                style="font-weight: 500"
              ></e-column>
              <e-column
                field="remHrs"
                headerText="Rem Hrs"
                width="110px"
                style="font-weight: 500"
              ></e-column>
              <e-column field="" headerText="EXP PROD" width="175px">
                <ng-template #template let-data>
                  <div *ngIf="data.isAdded || data.isAddedToJobSchedule">
                    {{ data.expProd }}
                  </div>
                  <div *ngIf="!data.isAdded && !data.isAddedToJobSchedule">
                    <ejs-textbox
                      placeholder="Enter value"
                      [(ngModel)]="data.expProd"
                    ></ejs-textbox>
                  </div>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>
        <div
          class="row mt-2"
          style="padding: 10px"
          *ngIf="showSelectedPhaseGrid"
        >
          <ejs-grid
            #selectedPhaseGrid
            class="px-0"
            [dataSource]="gridSelectedPhase"
            allowTextWrap="true"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [toolbar]="toolbar"
            [filterSettings]="filterSettings"
            allowSorting="true"
            [sortSettings]="sortOptions"
          >
            <e-columns>
              <e-column headerText="ACTION" width="100px">
                <ng-template #template let-gridDataSource>
                  <div>
                    <button
                      type="button"
                      ejs-button
                      Class="e-danger btn-bg mr-2"
                      title="Add"
                      (click)="PhaseDeleteSelectedPhase($event)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </ng-template>
              </e-column>
              <e-column
                field="phaseIdDescription"
                headerText="PHASE ID"
                width="220px"
                style="font-weight: 500"
              >
              </e-column>
              <e-column
                field="itemIdDescription"
                headerText="ITEM DESCRIPTION"
                width="350px"
                style="font-weight: 500"
              >
              </e-column>
              <e-column
                field="estLabourProd"
                headerText="BID PROD"
                width="125px"
                style="font-weight: 500"
              ></e-column>
              <e-column
                field="bidHrs"
                headerText="Bid Hrs"
                width="110px"
                style="font-weight: 500"
              ></e-column>
              <e-column
                field="jtdHrs"
                headerText="JTD Hrs"
                width="110px"
                style="font-weight: 500"
              ></e-column>
              <e-column
                field="remHrs"
                headerText="Rem Hrs"
                width="110px"
                style="font-weight: 500"
              ></e-column>
              <e-column field="expProd" headerText="EXP PROD" width="110px">
                <ng-template #template let-data>
                  <ejs-textbox
                    placeholder="Enter value"
                    [(ngModel)]="data.expProd"
                    (change)="OnExpProdChange($event)"
                  >
                  </ejs-textbox>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </ng-wizard-step>

      <ng-wizard-step [title]="'2 - Workforce'">
        <div
          style="width: 100%; height: 560px !important; overflow-y: auto"
          class="p-2"
        >
          <div class="">
            Show all company employees
            <ejs-switch
              id="timeline_views"
              (click)="ShowAllEmployees()"
              [checked]="false"
              [(ngModel)]="showAllEmployees"
            >
            </ejs-switch>
          </div>
          <ejs-accordion
            *ngFor="let item of selectedJobs.ActivePhase"
            class="mt-2"
          >
            <e-accordionitems>
              <e-accordionitem>
                <ng-template #header>
                  <div>
                    {{ item.phaseId }}{{ item.description }}
                    <span
                      *ngIf="
                        item.estLaborProd != null && item.estLaborProd != ''
                      "
                      >({{ item.estLaborProd }})</span
                    >
                    <span *ngIf="item.employees != null && item.employees != ''"
                      >({{ item.employees }})</span
                    >
                  </div>
                </ng-template>
                <ng-template #content>
                  <div class="row mt-2">
                    <span
                      *ngIf="
                        item.employeesFullName != null &&
                        item.employeesFullName != ''
                      "
                      class="text-secondary"
                      >Selected Employee(s): {{ item.employeesFullName }}</span
                    >
                    <ejs-grid
                      #addEmployeeGrid
                      class="px-0 mt-2"
                      allowTextWrap="true"
                      [dataSource]="item.workForce"
                      [allowPaging]="true"
                      [pageSettings]="workForcePageSettings"
                      [toolbar]="toolbar"
                      [filterSettings]="filterSettings"
                      allowSorting="true"
                      [sortSettings]="sortOptions"
                      (id)="(item.phaseId)"
                      (rowSelected)="rowSelected($event, item, addEmployeeGrid)"
                      (dataBound)="workForceDataBound(addEmployeeGrid)"
                    >
                      <e-columns>
                        <e-column headerText="ACTION" width="10%">
                          <ng-template #template let-empData>
                            <div>
                              <i
                                id="btnSelectEmployee"
                                class="fa fa-plus btn btn-primary mr-2"
                                *ngIf="
                                  !empData.isAdded &&
                                  empData.phaseId === item.phaseId
                                "
                              ></i>
                              <i
                                id="btnDeSelectEmployee"
                                class="fa fa-trash btn btn-danger mr-2"
                                *ngIf="
                                  empData.isAdded &&
                                  empData.phaseId === item.phaseId
                                "
                              ></i>
                            </div>
                          </ng-template>
                        </e-column>
                        <e-column
                          field=""
                          headerText="Phase Id"
                          [visible]="false"
                        >
                          <ng-template #template let-empData>
                            <div class="tempPhaseId">
                              {{ item.phaseId }}
                            </div>
                          </ng-template>
                        </e-column>
                        <e-column
                          field="employeeId"
                          headerText="EmployeeId"
                          style="font-weight: 500"
                          [visible]="false"
                        >
                        </e-column>
                        <e-column
                          field="companyId"
                          headerText="companyId"
                          style="font-weight: 500"
                          [visible]="false"
                        >
                        </e-column>
                        <e-column
                          field="fullNameForDisplayInGrid"
                          [sortComparer]="sortComparer"
                          headerText="EMPLOYEE"
                          width="20%"
                          style="font-weight: 500"
                        >
                        </e-column>
                        <e-column
                          field="worksForCompanyName"
                          headerText="COMPANY"
                          width="20%"
                          style="font-weight: 500"
                        >
                        </e-column>
                        <e-column
                          field="assignedJobs"
                          headerText="JOBS"
                          width="50%"
                          title="assignedJobs"
                          style="font-weight: 500"
                        >
                        </e-column>
                        <!-- <e-column field='notes' headerText='NOTES' width='350px' style="font-weight: 500;"></e-column> -->
                      </e-columns>
                    </ejs-grid>
                  </div>
                </ng-template>
              </e-accordionitem>
            </e-accordionitems>
          </ejs-accordion>
        </div>
      </ng-wizard-step>

      <ng-wizard-step [title]="'3 - Review'">
        <br />
        <div class="control-styles">
          <div class="row">
            <div class="col-12">
              <button
                class="float-end me-2 e-info"
                ejs-dropdownbutton
                [items]="items"
                (select)="select($event)"
                content="Actions"
              ></button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2 cl-sm-12">Company</div>
            <div class="col-md-3 cl-sm-12 text-secondary">
              {{ JobScheduleViewModel.companyName }}
            </div>
            <div class="col-md-2 cl-sm-12">Scheduled Date</div>
            <div class="col-md-4 cl-sm-12 text-secondary">
              {{ JobScheduleViewModel.startDate | date : "MM/dd/yyyy" }}
            </div>
          </div>

          <div class="row">
            <div class="col-md-2 cl-sm-12">Job</div>
            <div class="col-md-3 cl-sm-12 text-secondary">
              {{ JobScheduleViewModel.jobDescription }}
            </div>
            <div class="col-md-2 cl-sm-12">Scheduled By</div>
            <div class="col-md-4 cl-sm-12 text-secondary">
              {{ JobScheduleViewModel.createdBy }}
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-md-2 cl-sm-12">Inspector Called</div>
            <div class="col-md-3 cl-sm-12 text-secondary">{{JobScheduleViewModel.inspectorCalled?'Yes':'No'}}</div>
            <div class="col-md-2 cl-sm-12">Status</div>
            <div class="col-md-4 cl-sm-12 text-secondary"><span
                *ngIf="JobScheduleViewModel.jobScheduleStatusId===1">Draft</span>
              <span *ngIf="JobScheduleViewModel.jobScheduleStatusId===3">Scheduled</span>
            </div>


          </div> -->
          <!-- <div class="row">
            <div class="col-md-2 cl-sm-12">Inspector Needed</div>
            <div class="col-md-3 cl-sm-12 text-secondary">{{JobScheduleViewModel.inspectorNeeded?'Yes':'No'}}</div>

          </div> -->
          <br />
          <div
            class="text-black"
            [innerHTML]="JobScheduleViewModel.reviewHTML | safe : 'html'"
          ></div>
          <br />

          <div class="multiline-row">
            <ejs-textbox
              id="notes"
              #default
              rows="6"
              [(ngModel)]="JobScheduleViewModel.notes"
              placeholder="Enter your Notes"
              floatLabelType="Auto"
              [multiline]="true"
              required
            ></ejs-textbox>
          </div>
        </div>
      </ng-wizard-step>
      <div class="row m-1">
        <div class="col-lg-1 col-md-12 col-xs-12 mb-1">
          <button
            ejs-button
            id="btnPrevious"
            class="e-info btn-bg mx-1 w-100"
            *ngIf="btnPrevious"
            (click)="showPreviousStep('Previous')"
          >
            Previous
          </button>
        </div>
        <div class="col-lg-7 col-md-12 col-xs-12 mb-1 hidden-md-down"></div>
        <div class="col-lg-2 col-md-12 col-xs-12 mb-1">
          <button
            ejs-button
            id="btnClose"
            class="e-info btn-bg mx-1 w-100"
            *ngIf="JobScheduleViewModel.jobScheduleStatusId === 3"
            (click)="SaveAndClose('SaveClose')"
          >
            Save & Close
          </button>
        </div>
        <div class="col-lg-1 col-md-12 col-xs-12 mb-1">
          <button
            ejs-button
            id="btnSaveAsIncomplete"
            class="e-info btn-bg mx-1 w-100"
            (click)="CancelClick()"
          >
            Cancel
          </button>
        </div>
        <div class="col-lg-1 col-md-12 col-xs-12 mb-1">
          <button
            ejs-button
            id="btnNext"
            class="e-info btn-bg mx-1 w-100"
            *ngIf="btnNext"
            (click)="showNextStep('Next')"
          >
            Next
          </button>
          <button
            ejs-button
            id="btnFinish"
            class="e-info btn-bg mx-1 w-100"
            *ngIf="JobScheduleViewModel.jobScheduleStatusId !== 3 && btnFinish"
            (click)="SubmitJobSchedule()"
          >
            Finish
          </button>
        </div>
      </div>
    </ng-wizard>
  </div>
</div>
